module.exports = __webpack_public_path__ + "img/SKWINKELNetActieCampagneplanningCA526C.95728113.png";